import * as React from 'react';
import Rolling from 'src/core/ui/rolling';
import Container from 'src/core/ui/container';
import Button from 'src/core/ui/button';
import Divider from 'src/core/ui/divider';
import { resolve } from 'inversify-react';
import RollingDataService from './rolling-dataservice';
import Fade from 'react-reveal/Fade';
import images from "../../../assets/images/index";
import Card from "../../../core/ui/card";

export interface RollingHomeProps {
    onStart: () => void;
    isAuthenticated: boolean;
}

export interface RollingHomeState {
    currentImage: string;
    images: string[];
    index: number;
    enterOnce: boolean;

}

export default class RollingHome extends React.Component<RollingHomeProps, RollingHomeState> {
  constructor(props: RollingHomeProps) {
    super(props);

    this.state = {
        currentImage: '',
        images: [],
        index: 0,
        enterOnce: false
    }
  }

  @resolve
  dataService: RollingDataService;

  public componentDidMount(){
      var images = this.dataService.getImages().slice(50);

      const middle = 60
      this.setState({images, currentImage: images[middle], index: middle}, () => this.forceUpdate());

      //setInterval(this.changeImage, 800);
  }

  changeImage = () => {
      const index = (this.state.index + 1)%this.state.images.length;

      this.setState({currentImage: this.state.images[index], index})
  }


  handleRoll = (x, y) => {


     if(this.width > 0){
         let dx = x*(this.state.images.length)/this.width;

        dx = Math.floor(dx);
        
        const nIndex = dx;

        if(nIndex < this.state.images.length)
            this.setState({index: nIndex, currentImage: this.state.images[nIndex]});
     }

  }

  width: number;

  public render() {
      
    return (<Container className='full-width no-padding' style={{backgroundColor: 'white'}}>

            <Rolling ref={e => {
                if(e)
                this.width = e.width;
            }} onRoll={this.handleRoll}  data-transition-id={'home-page'} >
            <div className='home'>
                <div className="home-header fingerprint-bg" style={{backgroundImage: `url('${images.fingerprintArtworkSlide}')`}}>
                    <div>
                        <h2>VERIFY & CERTIFY SAFELY YOUR</h2>
                        <h1>Artwork</h1>
                        <p>using Blockchain Technology</p>
                    </div>
                    {!this.props.isAuthenticated && <Button onClick={this.props.onStart} className='start-button button default'>JOIN US</Button>}
                </div>
                <div className="home-header figure-bg" style={{backgroundImage: `url('${images.aboutBackground}')`}}>
                    <div className="card-container">
                        <h2>ENCRYPTO ART</h2>
                        <h4>The new tool for securing your artwork on the Symbol Blockchain</h4>
                        <Divider/>
                        {/* <div style={{padding: '0 20%'}}>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Numquam, labore necessitatibus.</p>
                        </div>
                        <div style={{padding: '0 10%'}}>
                            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Porro accusamus nulla reiciendis ex possimus maxime quas iure odio.</p>
                        </div> */}
                        {/* Mobile */}
                        <div style={{padding: '0 10%'}}>
                            <p>Prevent forgeries through NFT </p>
                            <p> Certificates and NFC Secure Chip technology</p>
                        </div>
                        <div className="signature">
                            <h5>AN INITIATIVE BY</h5>
                            <h4>Lorenzo Quinn</h4>
                            {/* <h4>FIRMA</h4> */}
                        </div>
                    </div>
                </div>             
            </div>

            </Rolling>
        </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/home/parts/rolling-home.tsx